export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const SIDEBAR_VISIBLE = 'HIDE_SIDEBAR'
export const IFRAME_TOP_MENU = 'IFRAME_TOP_MENU'
export const SIMULATED_ENVIROMENT = 'SIMULATED_ENVIROMENT'
